(() => {
  const root = document.querySelector('[data-marluna-ritual]');
  if (!root) return;
  const assetRoot = root.dataset.ritualAssetRoot || '';
  const products = {
    aethra:{name:'Aethra',handle:'aethra',image:'marluna-aethra-esoterica.png',copy:'Un percorso verso luce, verità e una direzione più chiara.'},
    aurea:{name:'Aurea',handle:'aurea',image:'marluna-aurea-esoterica.png',copy:'Un invito a ritrovare il proprio valore, la propria luce e autenticità.'},
    spiral:{name:'Cosmira / Spiralis',choices:[['Cosmira','cosmira','marluna-cosmira-esoterica.png'],['Spiralis','spiralis','marluna-spiralis-esoterica.png']],copy:'La Spirale Cosmica accompagna il passaggio dalla stasi al nuovo flusso.'},
    eclisse:{name:'Eclisse',handle:'eclisse',image:'marluna-eclisse-esoterica.png',copy:'L’incontro tra Sole e Luna per ricomporre le forze interiori.'},
    evola:{name:'Evola',handle:'evola',image:'marluna-evola-esoterica.png',copy:'Un simbolo di evoluzione, crescita e nuove possibilità.'},
    intrexis:{name:'Intrexis',handle:'intrexis',image:'marluna-intrexis-esoterica.png',copy:'Un richiamo a proteggere la propria energia e custodire il proprio spazio.'},
    nahara:{name:'Nahara',handle:'nahara',image:'marluna-nahara-esoterica.png',copy:'Un simbolo di rinascita, nuovi inizi e trasformazione delle ferite in saggezza.'},
    soluna:{name:'Soluna',handle:'soluna',image:'marluna-soluna-esoterica.png',copy:'La completezza dell’abbraccio tra Sole e Luna, con centratura e prosperità.'},
    taelia:{name:'Taelia',handle:'taelia',image:'marluna-taelia-esoterica.png',copy:'L’armonia dello Yin e dello Yang e la pace del proprio centro.'},
    vitala:{name:'Vitala',handle:'vitala',image:'marluna-vitala-esoterica.png',copy:'Radici, crescita e prosperità: stabilità mentre si apre una nuova fase.'}
  };
  const questions = [
    ['Cosa desideri ritrovare adesso?',[['Chiarezza per leggere meglio ciò che accade',['aethra','eclisse']],['Protezione e confini più saldi',['intrexis','taelia']],['Un nuovo inizio dopo una fase difficile',['nahara','aurea','vitala']],['Movimento, crescita e possibilità nuove',['evola','spiral','soluna']]]],
    ['Quale passaggio ti rappresenta di più?',[['Lasciare andare ciò che non appartiene più al tuo cammino',['evola','nahara','spiral']],['Sciogliere una stasi che ti tiene ferma',['spiral']],['Ricomporre due parti di te in conflitto',['eclisse','soluna','taelia']],['Difendere la tua energia da ciò che arriva dall’esterno',['intrexis','taelia']]]],
    ['In quale direzione vuoi portare la tua energia?',[['Verso intuizione e verità',['aethra','eclisse']],['Verso autenticità e valore personale',['aurea','nahara']],['Verso evoluzione e futuro',['evola','spiral']],['Verso stabilità, prosperità e crescita',['vitala','soluna']]]],
    ['Quando arriva il cambiamento, cosa ti serve di più?',[['Fiducia per procedere verso una versione più autentica di te',['evola','aurea']],['Coraggio per attraversare una trasformazione',['nahara','eclisse']],['Un nuovo flusso per uscire dal punto fermo',['spiral']],['Radici e centratura per non perdere equilibrio',['vitala','taelia','soluna']]]],
    ['Quale intenzione vuoi portare con te?',[['Vedere con più chiarezza prima di scegliere',['aethra']],['Ritrovare luce e valore dopo un periodo pesante',['aurea']],['Fare spazio al nuovo e tornare a fluire',['spiral','evola']],['Integrare forze diverse senza perdere il centro',['eclisse','soluna','taelia']]]],
    ['Cosa vuoi preservare nel tuo quotidiano?',[['Il tuo spazio sacro e inviolabile',['intrexis']],['La pace e il tuo equilibrio emotivo',['taelia']],['La centratura mentre costruisci crescita e prosperità',['vitala','soluna']],['La tua luce e la connessione con ciò che sei',['aurea','aethra']]]],
    ['Il talismano che cerchi dovrebbe ricordarti…',[['…che puoi vedere più chiaramente e scegliere con consapevolezza',['aethra','eclisse']],['…che il passato non definisce il tuo futuro',['nahara','aurea']],['…che puoi cambiare, evolvere e fare spazio al nuovo',['evola','spiral']],['…che la tua energia è preziosa e merita protezione e radici',['intrexis','taelia','vitala','soluna']]]]
  ];
  const state = { index:0, answers:[] };
  const $ = selector => root.querySelector(selector);
  const scenes = JSON.parse($('[data-gate-scenes]').textContent);
  const gateNames = ['Il risveglio', 'Lo specchio dell’anima', 'Il tempio delle stelle', 'Il fuoco interiore', 'Il giardino segreto', 'L’equilibrio cosmico', 'La soglia del destino'];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const layers = [...root.querySelectorAll('[data-gate-backdrop]')];
  const loaded = new Map();
  let activeLayer = 0;
  let sceneRevision = 0;
  let transitioning = false;
  const atmosphere = (() => {
    const world = $('.marluna-gates__world');
    const veil = document.createElement('div');
    veil.className = 'marluna-magic__layers';
    veil.innerHTML = '<div class="marluna-magic__rays"></div><div class="marluna-magic__water"></div><div class="marluna-magic__embers"></div><div class="marluna-magic__rings"><i></i><i></i><i></i></div><div class="marluna-magic__portal"></div><div class="marluna-magic__fog"></div><div class="marluna-magic__presence"></div><div class="marluna-magic__threshold"></div>';
    world.append(veil);
    const canvas = document.createElement('canvas');
    canvas.className = 'marluna-magic__particles';
    world.append(canvas);
    const ctx = canvas.getContext('2d');
    const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
    const constrained = (navigator.hardwareConcurrency || 4) <= 4 || (navigator.deviceMemory || 8) <= 4;
    let width = 1, height = 1, frame = 0, clock = 0, last = 0, visible = false;
    let burstAt = -10, burstX = .5, burstY = .25, reveal = false, disposed = false;
    const pointer = {x:0,y:0,tx:0,ty:0};
    const particles = Array.from({length:constrained ? 24 : mobile.matches ? 36 : 60}, (_,i) => ({
      x:((i * 73 + 17) % 101) / 101,
      y:((i * 47 + 29) % 103) / 103,
      phase:i * 2.39996, depth:.3 + (i % 7) / 10
    }));
    const resize = () => {
      const rect = world.getBoundingClientRect();
      width = rect.width; height = rect.height;
      const ratio = Math.min(devicePixelRatio || 1, constrained ? 1 : 1.5);
      canvas.width = Math.round(width * ratio); canvas.height = Math.round(height * ratio);
      if (ctx) ctx.setTransform(ratio,0,0,ratio,0,0);
    };
    const draw = now => {
      frame = 0;
      if (disposed || !visible || document.hidden || reducedMotion.matches) return;
      if (now - last < 32) { frame = requestAnimationFrame(draw); return; }
      clock += Math.min((now - last) / 1000, .06); last = now;
      pointer.x += (pointer.tx - pointer.x) * .06;
      pointer.y += (pointer.ty - pointer.y) * .06;
      root.style.setProperty('--magic-x', `${pointer.x * 7}px`);
      root.style.setProperty('--magic-y', `${pointer.y * 5}px`);
      if (ctx) {
        ctx.clearRect(0,0,width,height);
        const gate = Number(root.dataset.gate || 1);
        const elapsed = clock - burstAt;
        const burst = elapsed >= 0 && elapsed < 1.25;
        ctx.globalCompositeOperation = 'lighter';
        particles.forEach((p,i) => {
          const t = clock * (.18 + p.depth * .12);
          let x = p.x + Math.sin(t + p.phase) * .035;
          let y = p.y * .62 + Math.cos(t * .7 + p.phase) * .018;
          let alpha = .2 + .35 * (.5 + .5 * Math.sin(clock * .8 + p.phase));
          let size = .6 + p.depth * 1.8;
          if (gate === 2) {
            x = .5 + Math.sin(p.phase) * (.03 + p.y * .22);
            y = .28 + p.x * .27 + Math.sin(t + p.phase) * .006;
            alpha *= .55;
          } else if (gate === 3) {
            y = p.y * .35; x = p.x;
            alpha = .1 + .65 * Math.pow(.5 + .5 * Math.sin(t * 2 + p.phase),3);
          } else if (gate === 4) {
            x = (i % 2 ? .79 : .21) + Math.sin(t * 2 + p.phase) * .045;
            y = .48 - ((p.y + clock * (.025 + p.depth * .02)) % .42);
          } else if (gate === 5) {
            x = (p.x + Math.sin(t + p.phase) * .08 + 1) % 1;
            y = (p.y + clock * .012 * p.depth) % .65;
            size = 2 + p.depth * 4;
          } else if (gate === 6) {
            const angle = p.phase + clock * .045;
            x = .5 + Math.cos(angle) * (.12 + p.depth * .15);
            y = .24 + Math.sin(angle) * (.07 + p.depth * .08);
          } else if (gate === 7) {
            const radius = 1 - ((p.x + clock * .045) % 1);
            x = .5 + Math.cos(p.phase) * radius * .46;
            y = .25 + Math.sin(p.phase) * radius * .25;
            alpha *= Math.sin(radius * Math.PI);
          }
          if (burst && (gate === 5 || reveal)) {
            const radius = elapsed * (.08 + p.depth * .14);
            const angle = p.phase + (gate === 5 ? elapsed * 3 : 0);
            x = burstX + Math.cos(angle) * radius;
            y = burstY + Math.sin(angle) * radius * width / height;
            alpha *= 1 - elapsed / 1.25;
          }
          ctx.save();
          ctx.translate(x * width + pointer.x * p.depth * 12,y * height + pointer.y * p.depth * 8);
          ctx.fillStyle = `rgba(255,${gate === 4 ? 157 : 218},${gate === 4 ? 70 : 152},${alpha})`;
          if (gate === 5) {
            ctx.rotate(t + p.phase);
            ctx.beginPath(); ctx.ellipse(0,0,size,size * .35,0,0,Math.PI * 2); ctx.fill();
          } else {
            ctx.beginPath(); ctx.ellipse(0,0,gate === 2 ? size * 4 : size,size * .7,0,0,Math.PI * 2); ctx.fill();
          }
          ctx.restore();
        });
        if (gate === 3) {
          const stars = [[.22,.12],[.38,.08],[.48,.18],[.63,.1],[.77,.19]];
          const progress = burst ? Math.min(elapsed / .45,1) : (clock % 12) / 12;
          ctx.lineWidth = .8;
          ctx.strokeStyle = `rgba(255,218,152,${burst ? .65 * (1 - elapsed / 1.25) : .12})`;
          ctx.beginPath();
          stars.forEach(([x,y],i) => {
            if (!i) ctx.moveTo(x * width,y * height);
            else {
              const f = Math.max(0,Math.min(1,progress * 4 - (i - 1)));
              ctx.lineTo((stars[i-1][0] + (x-stars[i-1][0])*f)*width,(stars[i-1][1] + (y-stars[i-1][1])*f)*height);
            }
          });
          ctx.stroke();
        }
        ctx.globalCompositeOperation = 'source-over';
      }
      frame = requestAnimationFrame(draw);
    };
    const sync = () => {
      cancelAnimationFrame(frame); frame = 0;
      const running = visible && !document.hidden && !reducedMotion.matches;
      root.classList.toggle('is-atmosphere-paused',!running);
      if (running) { last = performance.now(); frame = requestAnimationFrame(draw); }
      else if (ctx && reducedMotion.matches) ctx.clearRect(0,0,width,height);
    };
    const move = event => {
      if (!finePointer.matches || reducedMotion.matches) return;
      const rect = root.getBoundingClientRect();
      pointer.tx = (event.clientX - rect.left) / rect.width * 2 - 1;
      pointer.ty = (event.clientY - rect.top) / rect.height * 2 - 1;
      root.style.setProperty('--magic-pointer-x',`${(pointer.tx + 1)*50}%`);
      root.style.setProperty('--magic-pointer-y',`${(pointer.ty + 1)*50}%`);
    };
    const leave = () => { pointer.tx = 0; pointer.ty = 0; };
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); },{threshold:0});
    observer.observe(root);
    const resizeObserver = new ResizeObserver(resize);
    resizeObserver.observe(world);
    document.addEventListener('visibilitychange',sync);
    reducedMotion.addEventListener('change',sync);
    root.addEventListener('pointermove',move,{passive:true});
    root.addEventListener('pointerleave',leave);
    const dispose = event => {
      if (!event.target.contains(root)) return;
      disposed = true; cancelAnimationFrame(frame); observer.disconnect(); resizeObserver.disconnect();
      document.removeEventListener('visibilitychange',sync);
      reducedMotion.removeEventListener('change',sync);
      document.removeEventListener('shopify:section:unload',dispose);
    };
    document.addEventListener('shopify:section:unload',dispose);
    resize();
    return {
      pulse(element, isReveal = false) {
        if (reducedMotion.matches) return;
        reveal = isReveal; burstAt = clock;
        if (isReveal) {
          const rect = element.getBoundingClientRect(), bounds = world.getBoundingClientRect();
          burstX = (rect.left + rect.width / 2 - bounds.left) / width;
          burstY = (rect.top + rect.height / 2 - bounds.top) / height;
        } else { burstX = .5; burstY = .25; }
      }
    };
  })();
  const loadScene = index => {
    const url = scenes[index][mobile.matches ? 'mobile' : 'desktop'];
    if (!loaded.has(url)) loaded.set(url, new Promise(resolve => {
      const image = new Image();
      image.onload = () => resolve(url);
      image.onerror = () => resolve('');
      image.src = url;
    }));
    return loaded.get(url);
  };
  const enterScene = async index => {
    const revision = ++sceneRevision;
    root.dataset.gate = String(index + 1);
    const url = await loadScene(index);
    if (revision !== sceneRevision || !root.isConnected) return;
    if (url) {
      activeLayer = 1 - activeLayer;
      layers[activeLayer].style.backgroundImage = `url("${url}")`;
      if (index === 6) root.style.setProperty('--gate-door-image', `url("${url}")`);
      layers[activeLayer].classList.add('is-visible');
      layers[1 - activeLayer].classList.remove('is-visible');
    }
    if (index < scenes.length - 1) loadScene(index + 1);
  };
  const animatePanel = () => {
    const panel = $('[data-ritual-quiz]');
    if (!reducedMotion.matches && panel.animate) panel.animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:550,easing:'ease-out'});
  };
  const render = () => {
    const [question, answers] = questions[state.index];
    $('[data-ritual-progress]').style.width = `${((state.index + 1) / questions.length) * 100}%`;
    $('[data-ritual-kicker]').textContent = `PORTA ${['I','II','III','IV','V','VI','VII'][state.index]} · ${state.index + 1} / 7`;
    $('[data-gate-name]').textContent = gateNames[state.index];
    $('[data-ritual-question]').textContent = question;
    $('[data-ritual-answers]').innerHTML = answers.map((answer, index) => `<button class="marluna-ritual__answer" type="button" data-answer="${index}" aria-pressed="${state.answers[state.index]?.answer === index}"><span class="marluna-gates__choice-mark" aria-hidden="true">${['I','II','III','IV'][index]}</span><span>${answer[0]}</span></button>`).join('');
    $('[data-ritual-back]').hidden = state.index === 0;
    root.querySelectorAll('[data-gate-steps] li').forEach((step,index) => {
      step.classList.toggle('is-complete',index < state.index);
      step.classList.toggle('is-current',index === state.index);
      if (index === state.index) step.setAttribute('aria-current','step'); else step.removeAttribute('aria-current');
    });
    enterScene(state.index);
    animatePanel();
    $('[data-ritual-question]').focus({preventScroll:true});
  };
  const result = () => { const scores = Object.fromEntries(Object.keys(products).map(key => [key, 0])); state.answers.forEach(({question, answer}) => questions[question][1][answer][1].forEach(key => { scores[key] += 1 / questions[question][1][answer][1].length; })); const winner = Object.entries(scores).sort((a,b) => b[1] - a[1])[0][0]; ceremony(winner); };
  const ceremony = key => { $('[data-ritual-quiz]').hidden = true; $('[data-ritual-ceremony]').hidden = false; root.classList.add('is-scene-7'); const orbit = $('[data-ritual-orbit]'); const nodes = Array.from({length:11}, (_, i) => `<span class="marluna-ritual__node" style="left:${50 + 42 * Math.cos((i / 11) * Math.PI * 2 - Math.PI / 2)}%;top:${50 + 42 * Math.sin((i / 11) * Math.PI * 2 - Math.PI / 2)}%"></span>`).join(''); orbit.innerHTML = nodes; const allNodes = [...orbit.children]; const targetIndex = {aethra:0,aurea:1,spiral:2,eclisse:4,evola:5,intrexis:6,nahara:7,soluna:8,taelia:9,vitala:10}[key]; allNodes.forEach((node, index) => setTimeout(() => node.classList.add('is-lit'), 160 + index * 110)); setTimeout(() => allNodes.forEach((node, index) => { if (index !== targetIndex) node.classList.remove('is-lit'); }), 160 + allNodes.length * 110 + 450); state.revealKey = key; };
  const show = key => { const product = products[key]; $('[data-ritual-quiz]').hidden = true; $('[data-ritual-result]').hidden = false; $('[data-ritual-result-title]').textContent = product.name; $('[data-ritual-result-copy]').textContent = product.copy; if (product.choices) { $('[data-ritual-result-media]').innerHTML = product.choices.map(choice => `<img src="${assetRoot}${choice[2]}" alt="${choice[0]}" loading="lazy">`).join(''); $('[data-ritual-result-actions]').innerHTML = product.choices.map(choice => `<a class="marluna-ritual__cta" href="/products/${choice[1]}">SCOPRI ${choice[0].toUpperCase()} →</a>`).join(''); } else { $('[data-ritual-result-media]').innerHTML = `<img src="${assetRoot}${product.image}" alt="${product.name}" loading="lazy">`; $('[data-ritual-result-actions]').innerHTML = `<a class="marluna-ritual__cta" href="/products/${product.handle}">SCOPRI ${product.name.toUpperCase()} →</a>`; } };
  const music = $('[data-ritual-music]');
  const accent = $('[data-ritual-accent]');
  const audioButton = $('[data-ritual-audio]');
  let audioEnabled = false;
  let revealAudio = false;
  let fadeFrame = 0;

  const fadeMusic = (target, duration, onComplete) => {
    cancelAnimationFrame(fadeFrame);
    const initial = music.volume;
    const start = performance.now();
    const tick = now => {
      const progress = Math.min((now - start) / duration, 1);
      music.volume = initial + (target - initial) * progress;
      if (progress < 1) fadeFrame = requestAnimationFrame(tick);
      else onComplete?.();
    };
    fadeFrame = requestAnimationFrame(tick);
  };

  const setAudio = enabled => {
    audioEnabled = enabled;
    audioButton.textContent = enabled ? 'Disattiva audio' : 'Attiva audio';
    cancelAnimationFrame(fadeFrame);
    if (!enabled) {
      music.pause();
      accent.pause();
      revealAudio = false;
      return;
    }
    music.volume = 1;
    music.play().catch(() => {
      if (music.paused) setAudio(false);
    });
  };

  const finishRevealAudio = () => {
    if (!revealAudio) return;
    revealAudio = false;
    if (!audioEnabled) return;
    music.play().then(() => {
      if (audioEnabled) fadeMusic(1, 850);
    }).catch(() => setAudio(false));
  };

  accent.addEventListener('ended', finishRevealAudio);
  accent.addEventListener('error', finishRevealAudio);

  const playRevealAudio = () => {
    if (!audioEnabled) return;
    revealAudio = true;
    fadeMusic(0, 450, () => {
      if (revealAudio) music.pause();
    });
    accent.currentTime = reducedMotion.matches ? .65 : 0;
    accent.play().catch(finishRevealAudio);
  };

  audioButton.addEventListener('click', () => setAudio(!audioEnabled));
  const pauseAudio = () => {
    cancelAnimationFrame(fadeFrame);
    accent.pause();
    music.pause();
    revealAudio = false;
    if (audioEnabled) setAudio(false);
  };
  window.addEventListener('pagehide', pauseAudio);
  document.addEventListener('shopify:section:unload', event => {
    if (!event.target.contains(root)) return;
    pauseAudio();
    window.removeEventListener('pagehide', pauseAudio);
  });
  root.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button || transitioning) return;
    if (button.matches('[data-ritual-start]')) {
      audioButton.hidden = false;
      setAudio(true);
      $('[data-ritual-intro]').hidden = true;
      $('[data-ritual-quiz]').hidden = false;
      render();
    }
    if (button.matches('[data-answer]')) {
      transitioning = true;
      state.answers[state.index] = {question:state.index, answer:Number(button.dataset.answer)};
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed','true');
      root.classList.add('is-answering');
      atmosphere.pulse(button);
      $('[data-ritual-answers]').setAttribute('aria-busy','true');
      setTimeout(() => {
        root.classList.remove('is-answering');
        $('[data-ritual-answers]').removeAttribute('aria-busy');
        state.index += 1;
        state.index < questions.length ? render() : result();
        transitioning = false;
      }, reducedMotion.matches ? 0 : state.index === 6 ? 1300 : 650);
    }
    if (button.matches('[data-ritual-back]')) {
      state.index = Math.max(0, state.index - 1);
      render();
    }
    if (button.matches('[data-ritual-reveal]')) {
      transitioning = true;
      atmosphere.pulse(button,true);
      root.classList.add('is-unsealing');
      setTimeout(() => {
        $('[data-ritual-ceremony]').hidden = true;
        $('[data-ritual-result]').hidden = false;
        show(state.revealKey);
        const title = $('[data-ritual-result-title]');
        title.tabIndex = -1;
        title.focus({preventScroll:true});
        root.classList.remove('is-unsealing');
        root.classList.add('is-revealed');
        transitioning = false;
      },reducedMotion.matches ? 0 : 650);
      try {
        playRevealAudio();
      } catch {
        finishRevealAudio();
      }
    }
  });
  mobile.addEventListener('change', () => enterScene(Math.min(state.index,6)));
  enterScene(0);
})();
